import type { SVGAttributes } from 'react';
import React from 'react';

type CartCloseIconProps = SVGAttributes<SVGSVGElement>;

const CartCloseIcon = (props: CartCloseIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 100 100" {...props}>
      <circle cx="50" cy="50" r="45" fill="transparent" stroke="black" strokeWidth="4" />
      <path d="M35 35 L65 65 M65 35 L35 65" stroke="black" strokeWidth="8" strokeLinecap="round" />
    </svg>
  );
};

export default CartCloseIcon;
